import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getAssetBean,
	getAssetBeanEndpoint,
	type QueryError,
	type GetAssetBeanResult,
	type GetAssetBeanRequestOptions,
} from '../getAssetBean';
export * from '../getAssetBean';

export type GetAssetBeanQueryParams = GetAssetBeanRequestOptions;
export type GetAssetBeanQueryKey = [string, GetAssetBeanQueryParams];

export const GetAssetBeanReactQueryKey = getAssetBeanEndpoint;

export type GetAssetBeanQueryOptions = Omit<
	UseQueryOptions<
		GetAssetBeanResult,
		QueryError,
		GetAssetBeanResult,
		GetAssetBeanQueryKey
	>,
	'queryKey'
>;

/**
 * react-query wrapper for `getAssetBean`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetAssetBean = (
	queryKeyParams: GetAssetBeanQueryParams,
	options?: GetAssetBeanQueryOptions,
) =>
	useQuery<
		GetAssetBeanResult,
		QueryError,
		GetAssetBeanResult,
		GetAssetBeanQueryKey
	>({
		queryKey: [GetAssetBeanReactQueryKey, queryKeyParams],
		queryFn: ({queryKey, signal}) => getAssetBean({...queryKey[1]}, signal),
		...options,
	});

export default useReactQueryGetAssetBean;
